<script setup>
// MCP araclarindan donen dizileri tabloya ceviren genel bilesen.
//
// Meta'nin donen alanlari araca gore degistigi icin sutunlar disaridan
// verilir; verilmezse ilk kaydin anahtarlarindan turetilir. Boylece 136 arac
// icin 136 ayri tablo yazmak gerekmiyor.
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import Spinner from 'dashboard/components-next/spinner/Spinner.vue';

const props = defineProps({
  satirlar: { type: Array, default: () => [] },
  // [{ anahtar: 'name', baslik: 'Ad', bicim: (deger, satir) => string }]
  sutunlar: { type: Array, default: () => [] },
  yukleniyor: { type: Boolean, default: false },
  bosMetin: { type: String, default: '' },
  // Sutun sayisini sinirla; cok alanli yanitlarda tabloyu okunmaz yapmasin.
  enFazlaSutun: { type: Number, default: 8 },
});

const { t } = useI18n();

const cozulmusSutunlar = computed(() => {
  if (props.sutunlar.length) return props.sutunlar;
  const ilk = props.satirlar[0];
  if (!ilk || typeof ilk !== 'object') return [];
  return Object.keys(ilk)
    .filter(k => {
      const d = ilk[k];
      return d === null || ['string', 'number', 'boolean'].includes(typeof d);
    })
    .slice(0, props.enFazlaSutun)
    .map(k => ({ anahtar: k, baslik: k }));
});

const hucre = (satir, sutun) => {
  const ham = satir?.[sutun.anahtar];
  if (sutun.bicim) return sutun.bicim(ham, satir);
  if (ham === null || ham === undefined || ham === '') return '—';
  if (typeof ham === 'boolean') return ham ? '✓' : '—';
  return String(ham);
};
</script>

<template>
  <div class="w-full">
    <div v-if="yukleniyor" class="flex justify-center p-10">
      <Spinner class="text-n-brand" />
    </div>

    <p v-else-if="!satirlar.length" class="p-8 text-sm text-center text-n-slate-11">
      {{ bosMetin || t('META_ADS.ORTAK.KAYIT_YOK') }}
    </p>

    <table v-else class="w-full text-sm">
      <thead class="text-left text-n-slate-11">
        <tr class="border-b border-n-weak">
          <th v-for="s in cozulmusSutunlar" :key="s.anahtar" class="px-3 py-2 font-normal">
            {{ s.baslik }}
          </th>
          <th v-if="$slots.eylemler" class="px-3 py-2" />
        </tr>
      </thead>
      <tbody>
        <tr
          v-for="(satir, i) in satirlar"
          :key="satir.id || i"
          class="border-b border-n-weak hover:bg-n-alpha-1"
        >
          <td
            v-for="s in cozulmusSutunlar"
            :key="s.anahtar"
            class="px-3 py-2.5 text-n-slate-12 align-top"
          >
            {{ hucre(satir, s) }}
          </td>
          <td v-if="$slots.eylemler" class="px-3 py-2.5 text-right whitespace-nowrap">
            <slot name="eylemler" :satir="satir" />
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>
